import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Home } from './pages/Home';
import { AmexCaseStudy } from './pages/AmexCaseStudy';
import { RsiCaseStudy } from './pages/RsiCaseStudy';
import { HotelPlannerCaseStudy } from './pages/HotelPlannerCaseStudy';
import { McKinseyCaseStudy } from './pages/McKinseyCaseStudy';
type AppProps = {
  /** McKinsey case study hero: the featured Aon video or the screenshot carousel. */
  mckinseyHeroMedia?: 'video' | 'carousel';
  /** American Express case study hero: the featured Amex video or the screenshot carousel. */
  amexHeroMedia?: 'video' | 'carousel';
};
export function App({
  mckinseyHeroMedia = 'video',
  amexHeroMedia = 'video'
}: AppProps) {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="28u5y0mx2p5cu">
      <BrowserRouter data-id="element-1" data-mp="28t4lee0esat0">
        <Routes data-id="element-2" data-mp="28sl5f2ubjwhm">
          <Route path="/" element={<Home data-id="element-4" data-mp="23vuo6c6s2uum" />} data-id="element-3" data-mp="28s2ztflro5x1" />
          <Route path="/case-studies/rsi" element={<RsiCaseStudy data-id="element-6" data-mp="23t8fuac2cbbc" />} data-id="element-5" data-mp="23u9ueosaffxt" />
          <Route path="/case-studies/hotelplanner" element={<HotelPlannerCaseStudy data-id="element-8" data-mp="3ijfvg0pldyf5" />} data-id="element-7" data-mp="3ik7eyd5x05p2" />
          <Route path="/case-studies/amex" element={<AmexCaseStudy heroMedia={amexHeroMedia} data-id="element-10" data-mp="3mkhnnxl3da7m" />} data-id="element-9" data-mp="3mlj82snzz920" />
          <Route path="/case-studies/amex-carousel" element={<AmexCaseStudy heroMedia="carousel" data-id="element-12" data-mp="3rdkh85pvcjnt" />} data-id="element-11" data-mp="3rc9dg5wfbbwp" />
          <Route path="/case-studies/mckinsey" element={<McKinseyCaseStudy heroMedia={mckinseyHeroMedia} data-id="element-14" data-mp="4n6a3ahwrb3" />} data-id="element-13" data-mp="5ygolyg4xb6" />
          <Route path="/case-studies/mckinsey-carousel" element={<McKinseyCaseStudy heroMedia="carousel" data-id="element-16" data-mp="2zmwhmy3ufmc9" />} data-id="element-15" data-mp="2zllff2q1qmn9" />
          <Route path="*" element={<Home data-id="element-18" data-mp="33nghwajpr62m" />} data-id="element-17" data-mp="33lwywc6oagx5" />
        </Routes>
      </BrowserRouter>
    </MotionConfig>;
}